/**
 * PDP product.set: repositions the installments banner + styles shopify-payment-terms.
 * Closed shadow: only host CSS (installment-banner-set.css) can help partially.
 */
(function () {
  const SELECTOR_PRODUCT_INFO = 'product-info[id^="MainProduct-"]';
  const SELECTOR_BANNER = '.product-installment-banner[data-reposition-in-checkout="true"]';
  const SELECTOR_BUTTONS = ".product-form__buttons";
  const SHADOW_STYLE_ID = "lasso-installments-content-override";

  function findMoreOptions(buttonsEl) {
    let el = buttonsEl.querySelector("more-payment-options-link");
    if (!el) {
      const byId = buttonsEl.querySelector("#more-payment-options-link");
      if (byId) el = byId.closest("more-payment-options-link") || byId.parentElement;
    }
    if (!el) {
      const anchor = buttonsEl.querySelector("a.shopify-payment-button__more-options");
      if (anchor) el = anchor.closest("more-payment-options-link") || anchor;
    }
    return el;
  }

  function repositionWithin(productInfo) {
    const banner = productInfo.querySelector(SELECTOR_BANNER);
    if (!banner) return;

    const buttons = productInfo.querySelector(SELECTOR_BUTTONS);
    if (!buttons) return;

    const moreOptions = findMoreOptions(buttons);
    if (!moreOptions) return;

    const slotOk = banner.getAttribute("slot") === "promise";
    if (moreOptions.previousElementSibling === banner && slotOk) return;

    if (moreOptions.previousElementSibling !== banner) {
      moreOptions.insertAdjacentElement("beforebegin", banner);
    }
    banner.setAttribute("slot", "promise");
  }

  function injectShadowOverrides(shadowRoot) {
    if (!shadowRoot || shadowRoot.querySelector(`#${SHADOW_STYLE_ID}`)) return;
    const style = document.createElement("style");
    style.id = SHADOW_STYLE_ID;
    style.textContent = `
      #shopify-installments-content,
      span#shopify-installments-content,
      [data-testid="shopify-installments-content"] {
        text-transform: initial !important;
        margin-top: 12px !important;
      }
    `;
    shadowRoot.appendChild(style);
  }

  function patchInstallmentsSpan(shadowRoot) {
    const span = shadowRoot.querySelector("#shopify-installments-content, [data-testid='shopify-installments-content']");
    if (!span) return;
    span.style.setProperty("text-transform", "initial", "important");
    span.style.setProperty("margin-top", "12px", "important");
  }

  const shadowContentObservers = new WeakMap();

  function observeShadowContent(host, shadowRoot) {
    if (shadowContentObservers.has(host)) return;
    let t;
    const mo = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => {
        injectShadowOverrides(shadowRoot);
        patchInstallmentsSpan(shadowRoot);
      }, 0);
    });
    mo.observe(shadowRoot, { childList: true, subtree: true });
    shadowContentObservers.set(host, mo);
  }

  function stylePaymentTermsHost(host) {
    const run = () => {
      const sr = host.shadowRoot;
      if (!sr) return false;
      injectShadowOverrides(sr);
      patchInstallmentsSpan(sr);
      observeShadowContent(host, sr);
      return true;
    };

    if (run()) return;

    const mo = new MutationObserver(() => {
      if (run()) mo.disconnect();
    });
    mo.observe(host, { childList: true, subtree: true });

    const started = performance.now();
    const poll = () => {
      if (run()) return;
      if (performance.now() - started < 10000) requestAnimationFrame(poll);
    };
    poll();

    setTimeout(() => mo.disconnect(), 10000);
  }

  function applyInstallmentsContentStyles(productInfo) {
    productInfo.querySelectorAll("shopify-payment-terms").forEach(stylePaymentTermsHost);
  }

  function repositionAll() {
    document.querySelectorAll(SELECTOR_PRODUCT_INFO).forEach((pi) => {
      repositionWithin(pi);
      applyInstallmentsContentStyles(pi);
    });
  }

  function init() {
    repositionAll();
    requestAnimationFrame(() => repositionAll());
    setTimeout(repositionAll, 100);
    setTimeout(repositionAll, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);

  const mainEl = document.querySelector("main");
  if (mainEl) {
    let debounceId;
    const mo = new MutationObserver(() => {
      clearTimeout(debounceId);
      debounceId = setTimeout(repositionAll, 16);
    });
    mo.observe(mainEl, { childList: true, subtree: true });
  }

  if (typeof customElements !== "undefined") {
    customElements
      .whenDefined("shopify-payment-terms")
      .then(() => repositionAll())
      .catch(() => {});
  }
})();
